import { Component, OnInit, Input } from '@angular/core';
import { Round } from '../../../objects/round';
import { Player } from '../../../objects/player';
import { jsPDF } from 'jspdf';
import { PlayerService } from 'src/app/services/player.service';


@Component({
  selector: 's18-handicap-card',
  templateUrl: './handicap-card.component.html',
  styleUrls: ['./handicap-card.component.scss']
})
export class HandicapCardComponent implements OnInit {

  @Input() player: Player;
  @Input() playerIndex: any;
  @Input() rounds: Round[];

  mouseOver: boolean = false;

  constructor(
  ) { }

  ngOnInit() {
  }


  downloadPdf() {
    var doc = new jsPDF();
    // @ts-ignore - addHTML was removed in jspdf v2, needs migration to html2canvas
    doc.addHTML(document.getElementById("handicap-card"), function () {
      doc.save("handicap-card.pdf");
    });
  }
  mouseIn() {
    this.mouseOver = true;
  }

  mouseOut() {
    this.mouseOver = false;
  }
}
